import { QuotaNotificationBanner } from "@Src/components/QuotaNotificationBanner";
import { QuotaWarningProvider } from "@Src/contexts/QuotaWarningContext";
import { ThemeSwapper } from "@Src/themes/ThemeSwapper";
import { Box } from "@mui/material";
import { LoadingIndicator } from "react-admin";

export const AppBarToolbar = () => (
	<QuotaWarningProvider>
		<Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center" }}>
			<QuotaNotificationBanner />
		</Box>
		<ThemeSwapper />
		<LoadingIndicator />
	</QuotaWarningProvider>
);
